
define('template!billingCodeTableTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="content m-r-0 m-l-0">\n\t<div class="billing-price-code-table jq-grid-table-page">\n\t  <div class="loading-block js-loading-block">\n\t    <span class="loading-message js-loading-message label"></span>\n\t  </div>\t\t\t      \n\t  <table id="jq-grid-billing-price" class="billingPriceTable" role="grid"></table>\n\t  <div id="jq-grid-pager-billing-price"></div>\n\t</div>\n</div>';

}
return __p
};});

